import { useAsyncData, useRoute, useRuntimeConfig } from '#imports'
import { ref, watch } from 'vue'

import { getAsyncDataKey } from '@backmarket/nuxt-module-http-v2/getAsyncDataKey'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'
import { isBrowser } from '@backmarket/utils/env/isBrowser'

import { useUrlParams } from '~/scopes/product-core/composables/useUrlParams/useUrlParams'
import { reviewsRequestEndpoints } from '~/scopes/reviews/reviews-display/constants'

function useFetchRatingDetailsSummary() {
  const route = useRoute()
  const { productId } = useUrlParams()
  const $httpFetch = useHttpFetch()

  const {
    public: { FF_REVIEWS_ENABLE_SUMMARY_SSR },
  } = useRuntimeConfig()

  const uuid: string = route.params?.uuid ? route.params.uuid : productId
  const routeName = route.name?.toString() ?? ''
  const endpoint = reviewsRequestEndpoints?.[routeName]?.getRatingDetailsSummary

  if (!endpoint) return { data: ref(), error: ref(), pending: ref(false) }

  return useAsyncData(
    getAsyncDataKey('reviews-rating-details-summary', { uuid, routeName }),
    () => {
      return $httpFetch(endpoint, {
        timeout: isBrowser() ? undefined : 2_000,
        pathParams: { uuid },
      })
    },
    {
      server: !!FF_REVIEWS_ENABLE_SUMMARY_SSR,
      lazy: true,
      dedupe: 'defer',
    },
  )
}

export function useRatingDetailsSummary() {
  const route = useRoute()
  const logger = useLogger()

  const { data, error, pending } = useFetchRatingDetailsSummary()

  watch(
    error,
    (err) => {
      if (err && err instanceof Error) {
        logger.error(`[REVIEWS][${route.name?.toString()}]`, {
          error: error.value,
          owners: ['bot-squad-content-front'],
        })
      }
    },
    { immediate: true },
  )

  return { data, pending }
}
